<template>
<div class="grid grid-cols-1 lg:grid-flow-col-dense">
  <div class="space-y-6 lg:col-span-1 lg:col-start-1">

    <!-- Graficos-->
    <section aria-labelledby="applicant-information-title">

      <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow">
        <div class="border-gray-200 bg-white px-4 py-2 sm:px-6">
          <div class="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
            <div class="ml-4 mt-2">
              <h3 class="text-lg font-medium leading-6 text-gray-900">Energía</h3>
            </div>
            <div class="ml-4 mt-2 flex-shrink-0 w-96">
               <v-date-picker
                color="orange"
                v-model="range"
                mode="dateTime"
                :masks="masks"
                class="w-96"
                is-range is24hr>

                <template v-slot="{ inputValue, inputEvents, isDragging, togglePopover }">
                  <div>
                    <div class="mt-1 flex rounded-md shadow-sm">
                      <div class="relative flex items-stretch flex-grow focus-within:z-10">
                        <input
                          :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                          :value="`${inputValue.start} -> ${inputValue.end}`"
                          v-on="inputEvents.start" type="text"
                          class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md sm:text-sm border-gray-300 text-center w-full" disabled />
                      </div>
                      <button @click="togglePopover({ placement: 'auto-start' })" class="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500">
                        <!-- Heroicon name: sort-ascending -->
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                    </button>
                  </div>
                  </div>
                </template>
              </v-date-picker>

            </div>
          </div>
        </div>

        <div class="px-4 py-3 sm:px-6">
          <energyvsproduction :block="selectedBlock" :range="range"/>
          <energydaily :block="selectedBlock"/>
          <energymonthly :block="selectedBlock"/>
        </div>
      </div>

    </section>

    <!-- Tabla de detalle -->
    <section aria-labelledby="notes-title">
      <treedatatable :items='blocks' :headers='headers'/>
    </section>
  </div>
</div>
</template>

<script>

import dayjs from 'dayjs';
import EnergyVsProduction from '@/components/energy/EnergyVsProduction';
import EnergyDaily from '@/components/energy/EnergyDaily';
import EnergyMonthly from '@/components/energy/EnergyMonthly';
import TreeDataTable from '@/components/TreeDataTable/TreeDataTable';

export default {
  name: 'energy',
  components: {
    energyvsproduction: EnergyVsProduction,
    energydaily: EnergyDaily,
    energymonthly: EnergyMonthly,
    treedatatable: TreeDataTable,
  },
  mounted() {
    this.fetchHeaders();
    this.fetchBlocks();
  },
  watch: {
    range() {
      this.fetchHeaders();
      this.fetchBlocks();
    }
  },
  methods: {
    updateRange() {
      console.log(this.range)
    },
    async fetchBlocks() {
      this.blocks = []
      let payload = {
        start: Math.round(this.range.start.getTime() / 1000),
        end: Math.round(this.range.end.getTime() / 1000)
      }
      const response = await this.$http.get(`/energy?funcname=getblocks&start=${payload.start}&end=${payload.end}`)
      this.blocks = response.data
      this.selectedBlock = this.blocks[0]
    },
    async fetchHeaders() {
      let response = await this.$http.get(`/tables?table=energy`);
      this.headers = response.data
    },
    toggleNode(node, open) {
      console.log(node, open)
    },
    onRowClicked(row) {
      console.log(row)
      this.selectedBlock = row
    },
    onRowDblClicked(row) {
      console.log(row)
    },
  },
  data() {
    return {
      selectedBlock: {},
      blocks: [],
      headers: [],
      masks: {
        input: 'DD/MM/YYYY h:mm A',
      },
      range: {
        start: dayjs().toDate(),
        end: dayjs().subtract(1, 'day').toDate()
      }
    }
  }
}
</script>
